import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedPaymentMethod: null,
  bankTransfer: {
    receipt: null
  },
  orderStatus: 'idle', // idle | processing | completed | failed
  error: null,
  orderData: null // بيانات الطلب
};

export const checkoutSlice = createSlice({
  name: 'checkout',
  initialState,
  reducers: {
    setPaymentMethod: (state, action) => {
      state.selectedPaymentMethod = action.payload;
    },
    setBankTransferReceipt: (state, action) => {
      state.bankTransfer.receipt = action.payload;
    },
    startProcessingOrder: (state) => {
      state.orderStatus = 'processing';
      state.error = null;
    },
    completeOrder: (state) => {
      state.orderStatus = 'completed';
    },
    failOrder: (state, action) => {
      state.orderStatus = 'failed';
      state.error = action.payload;
    },
    resetCheckout: () => initialState,
    setOrderData: (state, action) => {
      state.orderData = action.payload;
    }
  }
});

export const {
  setPaymentMethod,
  setBankTransferReceipt,
  startProcessingOrder,
  completeOrder,
  failOrder,
  resetCheckout,
  setOrderData
} = checkoutSlice.actions;

export default checkoutSlice.reducer;
